import { countBy, meanBy } from 'lodash-es';
export const getAvgRating = (reviews) => meanBy(reviews, 'rating').toFixed(1);
export const round = (value, step) => {
    const inv = 1.0 / step;
    return Math.round(value * inv) / inv;
};
/*
  @param: reviews {array} - totat value
  Returns: grouped reviews {object} based on ratings.
*/
export const groupdByRatings = (reviews) => (countBy(reviews, (r) => round(r.rating, 1)));
export default {};
//# sourceMappingURL=rating.js.map